/**
 * Template: <namespace>/utils/app/<namespaceCamel>.ts
 * Admin metadata (project name, etc.)
 */
import { DEFAULT_ADMIN_NAMESPACE, resolveAdminNamespace } from '@next-adapter/config/namespace.js'

export function adminDataTemplate(
  projectName: string,
  namespaceValue = DEFAULT_ADMIN_NAMESPACE
): string {
  const namespace = resolveAdminNamespace(namespaceValue)

  return `export const ${namespace.camel} = {
  name: '${projectName}',
}
`
}
